// import React from 'react'
import { useLocation } from 'react-router-dom'
import ImageWithBasePath from '../../../../core/common/imageWithBasePath'
// import { all_routes } from '../../../router/all_routes'
import StudentModals from '../studentModals'
import StudentSidebar from './studentSidebar'
import StudentBreadcrumb from './studentBreadcrumb'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../../../core/data/redux/store'
import { getSchoolById } from '../../../../core/data/services/schoolService'
import { setSelectedSchool } from '../../../../core/data/redux/schoolSlice'
import { useEffect } from 'react'

const StudentDetails = () => {
  // const routes = all_routes
  const location = useLocation();
  const dispatch = useDispatch()
  const studentFromState = location.state?.student;
  console.log("Student Details:", studentFromState);

  // Get user data from Redux
  const user = useSelector((state: RootState) => state.user);
  const schoolId = user.Users[0].relatedEntity?.schools?.id;

  useEffect(() => {
    const loadSchoolData = async () => {
      try {
        const school = await getSchoolById(schoolId);
        if (school) {
          dispatch(setSelectedSchool(school));
        } else {
          console.error('School not found for user:', user.Users[0]?.relatedEntity?.schools?.name);
        }
      } catch (error) {
        console.error('Error loading school data:', error);
      }
    };

    if (user && user.Users.length > 0) {
      loadSchoolData();
    }
  }, [dispatch, user, schoolId]);

  const selectSchool = useSelector((state: RootState) => state.school.selectedSchool)
  console.log("schoolList", selectSchool)

  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          <div className="row">
            {/* Page Header */}
            <StudentBreadcrumb studentFromState={studentFromState} />
            {/* /Page Header */}
          </div>
          <div className="row">
            {/* Student Information */}
            <StudentSidebar />
            {/* /Student Information */}
            <div className="col-xxl-9 col-xl-8">
              <div className="row">
                <div className="col-md-12">
                  {/* Parents Information */}
                  <div className="card">
                    <div className="card-header">
                      <h5>Parents Information</h5>
                    </div>
                    <div className="card-body">
                      <div className="border rounded p-3 pb-0 mb-3">
                        <div className="row">
                          <div className="col-sm-6 col-lg-4">
                            <div className="d-flex align-items-center mb-3">
                              <span className="avatar avatar-lg flex-shrink-0">
                                <ImageWithBasePath
                                  src="assets/img/parents/parent-13.jpg"
                                  className="img-fluid rounded"
                                  alt="img"
                                />
                              </span>
                              <div className="ms-2 overflow-hidden">
                                <h6 className="text-truncate">{studentFromState.fatherName}</h6>
                                <p className="text-primary">Father</p>
                              </div>
                            </div>
                          </div>
                          <div className="col-sm-6 col-lg-4">
                            <div className="mb-3">
                              <p className="text-dark fw-medium mb-1">Father Aadhar</p>
                              <p>{studentFromState.fatherAadhar}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="border rounded p-3 pb-0 mb-3">
                        <div className="row">
                          <div className="col-lg-4 col-sm-6 ">
                            <div className="d-flex align-items-center mb-3">
                              <span className="avatar avatar-lg flex-shrink-0">
                                <ImageWithBasePath
                                  src="assets/img/parents/parent-14.jpg"
                                  className="img-fluid rounded"
                                  alt="img"
                                />
                              </span>
                              <div className="ms-2 overflow-hidden">
                                <h6 className="text-truncate">{studentFromState.motherName}</h6>
                                <p className="text-primary">Mother</p>
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-4 col-sm-6 ">
                            <div className="mb-3">
                              <p className="text-dark fw-medium mb-1">Mother Aadhar</p>
                              <p>{studentFromState.motherAadhar}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* /Parents Information */}
                </div>
                {/* Address */}
                <div className="col-xxl-12 d-flex">
                  <div className="card flex-fill">
                    <div className="card-header">
                      <h5>Address</h5>
                    </div>
                    <div className="card-body">
                      <div className="d-flex align-items-center mb-3">
                        <span className="avatar avatar-md bg-light-300 rounded me-2 flex-shrink-0 text-default">
                          <i className="ti ti-map-pin-up" />
                        </span>
                        <div>
                          <p className="text-dark fw-medium mb-1">
                            Current Address
                          </p>
                          <p>{studentFromState.address}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* /Address */}
                {/* Previous School Details */}
                <div className="col-xxl-12">
                  <div className="card">
                    <div className="card-header">
                      <h5>School Details</h5>
                    </div>
                    <div className="card-body pb-1">
                      <div className="row">
                        <div className="col-md-6">
                          <div className="mb-3">
                            <p className="text-dark fw-medium mb-1">
                              School Name
                            </p>
                            <p>{studentFromState.school}</p>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <p className="text-dark fw-medium mb-1">
                              School Address
                            </p>
                            <p>{selectSchool?.address}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* /Previous School Details */}
              
                {/* Medical History */}
                <div className="col-xxl-12 d-flex">
                  <div className="card flex-fill">
                    <div className="card-header">
                      <h5>Medical History</h5>
                    </div>
                    <div className="card-body pb-1">
                      <div className="row">
                        <div className="col-md-6">
                          <div className="mb-3">
                            <p className="text-dark fw-medium mb-1">Physically Challenged</p>
                            <span className="badge bg-light text-dark">
                              {studentFromState.physicallyChallenged ? 'Yes' : 'No'}
                            </span>
                          </div>
                        </div>
                        {studentFromState.physicallyChallenged && (
                          <div className="col-md-6">
                            <div className="mb-3">
                              <p className="text-dark fw-medium mb-1">Physical Challenge Details</p>
                              <p>{studentFromState.physicalChallengeDetails || 'Not specified'}</p>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                {/* /Medical History */}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Page Wrapper */}
      <StudentModals />
    </>

  )
}

export default StudentDetails